/**
 * Copyright (c) 2020 Siemens Inc.
 * Unpublished - All rights reserved
 * 
 */
import React from 'react';
import {
  Card, CardText, CardBody,
  CardHeader
} from 'reactstrap';

const ContentCard = (props) => {

    const { cardHeader, cardText } = props;
    return (
        <div>
            <Card>
                <CardHeader>{cardHeader}</CardHeader>
                <CardBody>
                    <pre><CardText>{cardText}</CardText></pre>
                </CardBody>
            </Card>
        </div>
    );
};

export default ContentCard;